import { render, staticRenderFns } from "./kinesis-element.vue?vue&type=template&id=f50f2ecc&"
import script from "./kinesis-element.vue?vue&type=script&lang=js&"
export * from "./kinesis-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports